// extracted by mini-css-extract-plugin
export var formContainer = "_jl-0";
export var message = "_jl-1";